(() => {
  const init = () => {
    const bar = document.querySelector('[data-ozq-sticky]');
    const form = document.getElementById('RepairQuoteForm');
    const quote = document.getElementById('repair-quote');
    if (bar && form && !bar.dataset.initialized) {
      bar.dataset.initialized = 'true';
      const update = () => {
        const rect = form.getBoundingClientRect();
        const formVisible = rect.top < window.innerHeight && rect.bottom > 0;
        const editing = ['INPUT', 'TEXTAREA', 'SELECT'].includes(document.activeElement?.tagName);
        const modal = !!document.querySelector('body.overflow-hidden, body.overflow-hidden-mobile, body.overflow-hidden-tablet, #Details-menu-drawer-container[open]');
        bar.hidden = formVisible || editing || modal;
      };
      new IntersectionObserver(update).observe(form);
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      document.addEventListener('focusin', update);
      document.addEventListener('focusout', () => requestAnimationFrame(update));
      document.addEventListener('toggle', update, true);
      update();
    }
    const message = quote?.querySelector('[role="alert"], [data-ozq-success]');
    if (message) message.focus({ preventScroll: false });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
